<template>
    <div>
        <el-form
            ref="resetPwd_form"
            :rules="rules"
            :label-position="labelPosition"
            label-width="80px"
            :model="resetPwd_form"
        >
            <!-- 旧密码 -->
            <el-form-item :label="$t('navbar.oldPassword')" prop="oldPassword">
                <el-input v-model="resetPwd_form.oldPassword"></el-input>
            </el-form-item>
            <!-- 新密码 -->
            <el-form-item :label="$t('navbar.newPassword')" prop="newPassword">
                <el-input v-model="resetPwd_form.newPassword"></el-input>
            </el-form-item>
            <!-- 确认密码 -->
            <el-form-item :label="$t('navbar.confirmPassword')" prop="confirmPassword">
                <el-input v-model="resetPwd_form.confirmPassword"></el-input>
            </el-form-item>
        </el-form>
        <div style="text-align: right">
            <el-button @click="cancel">{{ $t("public.cancel") }}</el-button>
            <el-button type="primary" @click="restPwdConfirmRole('resetPwd_form')">
                {{ $t("public.save") }}
            </el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "resetPwd",
    data() {
        var validatePass = (rule, value, callback) => {
            const reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,20}$/;
            if (value === "") {
                callback(new Error(this.$t("login.enterPassword"))); // 请输入密码
            } else if (!value.match(reg)) {
                callback(new Error(this.$t("login.tip_P"))); // 必须包含大小写字母和数字，可以使用特殊字符，长度在8-20之间
            } else {
                if (this.resetPwd_form.confirmPassword !== "") {
                    this.$refs.resetPwd_form.validateField("confirmPassword");
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error(this.$t("login.tip_PCYP"))); // 请再次输入密码
            } else if (value !== this.resetPwd_form.newPassword) {
                callback(new Error(this.$t("login.tip_TT"))); // 两次输入密码不一致!
            } else {
                callback();
            }
        };
        return {
            labelPosition: "right",
            resetPwd_form: {
                oldPassword: "",
                newPassword: "",
                confirmPassword: "",
            },
            rules: {
                oldPassword: [
                    { required: true, trigger: "blur", message: this.$t("login.enterPassword") },
                ],
                newPassword: [{ required: true, validator: validatePass, trigger: "blur" }],
                confirmPassword: [{ required: true, validator: validatePass2, trigger: "blur" }],
            },
        };
    },

    methods: {
        cancel() {
            this.$emit("cancel");
        },
        restPwdConfirmRole(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$emit("restPwdConfirmRole", this.resetPwd_form);
                } else {
                    return false;
                }
            });
        },
    },
};
</script>

<style scoped>
</style>
